import * as Yup from 'yup';

import { EMAIL_MATCH_REGEXP } from 'constants/RegExp';

export const LoginSchema = Yup.object().shape({
    email: Yup.string()
        .required('validation.email.required')
        .trim()
        .matches(EMAIL_MATCH_REGEXP, 'validation.email.invalid'),
});
